import React, { useEffect, useState } from "react";
import { Container, Form, Row, Col, Button, Card } from "react-bootstrap";
import { Box } from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import reportApi from "../../services/reportapi";
import branchApi from "../../services/branchapi";
import Loader from "../loader/loader";
import DynamicBreadcrumb from "../header/breadcrumb";

const PickerPackerSummaryReport = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [branches, setBranches] = useState([]);
    const [rows, setRows] = useState([]);

    const [filters, setFilters] = useState({
        from_date: moment().format("YYYY-MM-DD"),
        to_date: moment().format("YYYY-MM-DD"),
        branch_id: "",
    });

    const updateFilters = (key, value) => {
        setFilters((prev) => ({ ...prev, [key]: value }));
    };

    const fetchBranches = async () => {
        const res = await branchApi.getAllBranches({
            limit: 200,
            page: 0,
            status: 1,
            sortModel: [{ field: "branchName", sort: "asc" }],
        });
        setBranches(res?.data?.result || []);
    };

    const fetchReport = async () => {
        setLoading(true);
        try {
            const res = await reportApi.getPickerPackerSummary(filters);
            const data = res?.data || [];
            setRows(data.map((x, i) => ({ id: i + 1, ...x })));
        } catch (err) {
            console.error("Picker packer summary report error:", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchBranches();
        fetchReport();
    }, []);

    const columns = [
        { field: "branch_name", headerName: "Branch", flex: 1.5 },
        { field: "picking_orders", headerName: "Picked Orders", flex: 1 },
        { field: "avg_picking_minutes", headerName: "Avg Picking Min", flex: 1 },
        { field: "packing_orders", headerName: "Packed Orders", flex: 1 },
        { field: "avg_packing_minutes", headerName: "Avg Packing Min", flex: 1 },
        { field: "newly_added_items", headerName: "New Items", flex: 1 },
        { field: "qty_updated_items", headerName: "Updated Qty", flex: 1 },
        { field: "removed_items", headerName: "Removed", flex: 1 },
    ];

    return (
        <Container fluid className="mt-4 mb-4">
            <DynamicBreadcrumb pathArray={[{ name: "Picker / Packer Summary Report", url: null }]} />

            <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="mb-0">Picker / Packer Summary Report</h5>

                <div className="d-flex gap-2">
                    <Button
                        size="sm"
                        variant="primary"
                        onClick={() => navigate("/admin/reports/picker-packer-item-changes")}
                    >
                        New / Updated / Removed Items Report
                    </Button>

                    <Button
                        size="sm"
                        variant="success"
                        onClick={() => navigate("/admin/reports/picker-packer-order-time")}
                    >
                        Order Wise Picking & Packing Time Report
                    </Button>
                </div>
            </div>
            <Form className="mb-3">
                <Row>
                    <Col md={3}>
                        <Form.Label>Branch</Form.Label>
                        <Form.Select
                            value={filters.branch_id}
                            onChange={(e) => updateFilters("branch_id", e.target.value)}
                        >
                            <option value="">All Branches</option>
                            {branches.map((branch) => (
                                <option key={branch.branchId} value={branch.branchId}>
                                    {branch.branchName}
                                </option>
                            ))}
                        </Form.Select>
                    </Col>

                    <Col md={3}>
                        <Form.Label>From Date</Form.Label>
                        <Form.Control
                            type="date"
                            value={filters.from_date}
                            onChange={(e) => updateFilters("from_date", e.target.value)}
                        />
                    </Col>

                    <Col md={3}>
                        <Form.Label>To Date</Form.Label>
                        <Form.Control
                            type="date"
                            value={filters.to_date}
                            onChange={(e) => updateFilters("to_date", e.target.value)}
                        />
                    </Col>

                    <Col md={3} className="d-flex align-items-end">
                        <Button className="w-100" onClick={fetchReport}>
                            Filter
                        </Button>
                    </Col>
                </Row>
            </Form>

            {loading && <Loader />}

            <Card>
                <Card.Header>Branch Summary</Card.Header>
                <Card.Body>
                    <Box sx={{ width: "100%" }}>
                        <DataGrid
                            rows={rows}
                            columns={columns}
                            autoHeight
                            disableRowSelectionOnClick
                            slots={{ toolbar: GridToolbar }}
                        />
                    </Box>
                </Card.Body>
            </Card>
        </Container>
    );
};

export default PickerPackerSummaryReport;